{
	"orderTypes": {
		"label": "Тип ордера",
		"market": "Рыночный",
		"limit": "Лимитный",
		"stop": "Стоп",
		"stop_limit": "Стоп-лимитный",
		"trailing_stop": "Трейлинг-стоп"
	}
}
